module.exports = __webpack_public_path__ + "static/media/team-ergopraxis-soest-startseite.e29dc3ae.jpg";